import { ResponseType, request } from 'frontendCheckout/services/fetch'

import { endpoints } from './endpoints'

export type SimilarProducts = {
  title: string
  slug: string
  originProductId: number
  products: Products[]
}

export type Products = {
  id: number
  name: string
  shortName: string
  picture: string
  unit: string
  url: string
  meta: {
    hasService: boolean
    hasVariants: boolean
    inWishlist: boolean
    isOutlet: boolean
    isSoldOut: boolean
  }
  tag: {
    type: string
    label: string
  }
  installments: {
    amount: number
    value: string
  }
  price: {
    to: number
    from: number | null
    region: string
    discount: {
      discountType: string
      paymentMethodsDiscount: string
    } | null
  }
  brand: string
  categoryTree: string
  sellerName: string | null
  skuId: string
  translatedUnit: string
}

export type response =
  | ResponseType<200, { data: SimilarProducts[] }>
  | ResponseType<204, null>

export type status =
  response extends ResponseType<infer Code, unknown> ? Code : never

export type props = {
  productId: number
}

export const getSimilarProducts = ({ productId }: props) => {
  return request<response>({
    url: endpoints.products(productId),
    params: { type: ['similarProducts'] },
    method: 'GET',
    errors: [204]
  })
}
